import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pencil, Trash2, Plus } from "lucide-react";
import api from "../../api/axios";

export default function Dashboard() {
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [tab, setTab] = useState("products");

  useEffect(() => {
    api.get("/products", { params: { limit: 100 } }).then((res) => setProducts(res.data.products));
    api.get("/orders/all").then((res) => setOrders(res.data)).catch(() => {});
  }, []);

  const deleteProduct = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    await api.delete(`/products/${id}`);
    setProducts(products.filter((p) => p._id !== id));
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-display font-semibold text-2xl">Admin dashboard</h1>
        <Link to="/admin/products/new" className="flex items-center gap-2 bg-accent text-black rounded-full px-4 py-2 text-sm font-semibold">
          <Plus size={16} /> New product
        </Link>
      </div>

      <div className="flex gap-4 mb-6 border-b border-white/10">
        {["products", "orders"].map((t) => (
          <button key={t} onClick={() => setTab(t)}
            className={`pb-3 text-sm font-medium capitalize ${tab === t ? "text-accent border-b-2 border-accent" : "text-white/50"}`}>
            {t}
          </button>
        ))}
      </div>

      {tab === "products" && (
        <div className="space-y-2">
          {products.map((p) => (
            <div key={p._id} className="flex items-center justify-between bg-surface border border-white/10 rounded-lg p-4">
              <div>
                <div className="font-medium text-sm">{p.name}</div>
                <div className="text-xs text-white/40 font-mono">{p.category?.name} · ₹{p.price.toFixed(2)} · stock {p.stock}</div>
              </div>
              <div className="flex gap-2">
                <Link to={`/admin/products/${p._id}/edit`} className="p-2 bg-white/5 rounded-lg hover:bg-white/10"><Pencil size={14} /></Link>
                <button onClick={() => deleteProduct(p._id)} className="p-2 bg-white/5 rounded-lg hover:bg-red-500/20 text-red-400"><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === "orders" && (
        <div className="space-y-2">
          {orders.map((o) => (
            <div key={o._id} className="flex items-center justify-between bg-surface border border-white/10 rounded-lg p-4 text-sm">
              <span className="font-mono text-white/60">#{o._id.slice(-6)}</span>
              <span>{o.user?.name}</span>
              <span>{o.status}</span>
              <span className="font-mono">₹{o.totalPrice.toFixed(2)}</span>
            </div>
          ))}
          {orders.length === 0 && <p className="text-white/40 text-sm">No orders yet.</p>}
        </div>
      )}
    </div>
  );
}
